/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */
import {
    Polymer,
    html
} from '@polymer/polymer/polymer-legacy.js';
import '../../../behaviors/app-menu-access-behaviour.js';

const template = html `<style include="app-styles">
            .border-round-brand-color{
                border:1px solid var(--brand-color);                
                border-radius :24px;
            }
            .padding-4px{
                padding: 4px;
            }
            /*Sandeep Changes Starts*/

            @media only screen and (min-device-width : 320px) and (max-device-width : 767px){
                .text-brand-color{
                    color:var(--primary-light-color) !important;
                }
                .secondary-dark-text-l,.secondary-dark-text-xxl,.secondary-dark-text-s{
                    color:var(--primary-light-color);
                }
                .border-round-brand-color{
                    border:1px solid var(--primary-light-color);
                }
            }
            
            /*Sandeep Changes ends*/
		</style>
        
        <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}"></app-media-query>

        <div class$="{{_addClassBasedOnDevice(desktop)}}">
        <div tabindex="0" on-tap="_navigateToCard" on-keydown="_navigateToCardDDA" class="outlineOffset">
            <div hidden$="{{!desktop}}" class="text-transform-uppercase disabled-dark-color font-size-s">
                <oe-i18n-msg msgid="h_Cards"></oe-i18n-msg>
                <div class="padding-4px"></div>
            </div>
            <template is="dom-if" if="{{cardLoader}}">
                <paper-spinner id="dashboard_user_card_spinner" active></paper-spinner>
            </template>
            <template is="dom-if" if="{{!cardLoader}}">
                <template is="dom-if" if="{{!isMenuId}}">
                    <div hidden$={{!cardsAvailable}}>
                        <div>
                            <div class="secondary-dark-text-s" hidden$="{{desktop}}">
                                <oe-i18n-msg msgid="m_DashboardMessage1"></oe-i18n-msg>
                            </div>
                            <template is="dom-repeat" items="{{cardsAmountList}}">
                                <div id="dashboard_user_card_amount_{{index}}">
                                    <div class="outlineOffset secondary-dark-text-xxl font-weight-bold cursor-pointer" on-tap="_navigateToCard" hidden$="{{desktop}}" tabindex="0">
                                        <currency-formator format-value={{item.amount}}></currency-formator>
                                    </div>
                                    <div class="outlineOffset secondary-dark-text-l font-weight-bold cursor-pointer" on-tap="_navigateToCard" hidden$="{{!desktop}}" tabindex="0">
                                        <currency-formator format-value={{item.amount}} tooltipnotrequired={{!item.showTooltip}} formatting-amount=true></currency-formator>
                                    </div>
                                </div>
                            </template>
                            <div class="secondary-dark-text-xs" hidden$="{{!desktop}}">
                                <oe-i18n-msg msgid="m_DashboardMessage1"></oe-i18n-msg>
                            </div>
                        </div>
                        <div class="mdl-grid" hidden$="{{desktop}}">
                            <div class="mdl-cell mdl-cell--12-col content-align-center">
                                <iron-icon icon="info-outline" class="iron-icon-style-m warning-color"></iron-icon>&nbsp;
                                <span class="secondary-dark-text-s cursor-pointer">
                                    <oe-i18n-msg msgid="l_TotalBilled"></oe-i18n-msg>&nbsp;
                                    <currency-formator format-value={{lastBilledAmount}}></currency-formator>
                                </span>
                            </div>
                        </div>
                        <div class="content-align-vertical-center" hidden$="{{!desktop}}">
                            <iron-icon icon="info-outline" class="warning-color"></iron-icon>&nbsp;
                            <span class="secondary-dark-text-xs cursor-pointer">
                                <oe-i18n-msg msgid="l_TotalBilled"></oe-i18n-msg>&nbsp;
                                <currency-formator format-value={{lastBilledAmount}}></currency-formator>
                            </span>
                        </div>
                    </div>
    
                    <div hidden$={{cardsAvailable}}>
                        <div hidden$={{desktop}}>
                        <!--Sandeep changes-->
                            <div hidden$={{tablet}}>
                                <div class="outlineOffset secondary-dark-text-xxl font-weight-bold" on-tap="_navigateToCard" tabindex="0">
                                    {{cardsSuggestions.formattedAmount}}
                                </div>
                                <div class="secondary-dark-text-s">
                                    {{cardsSuggestions.text}}
                                </div>
                            </div>
                        </div>
                        <div hidden$={{!desktop}}>
                            <div class="secondary-dark-text-l font-weight-bold">
                                {{cardsSuggestions.formattedAmount}}
                            </div>
                            <div class="secondary-dark-text-xs">
                                {{cardsSuggestions.text}}
                            </div>
                        </div>
                    </div>
                </template>
                <template is="dom-if" if="{{isMenuId}}">
                    <oe-i18n-msg class="font-size-m" msgid="l_PermissionErrorMessage"></oe-i18n-msg>
                </template>
    
            </template>
        </div>
        <template is="dom-if" if="{{!cardLoader}}">
            <template is="dom-if" if="{{!isMenuId}}">
                <div hidden$={{cardsAvailable}}>
                    <div hidden$={{desktop}} class="mdl-grid">
                        <div class="mdl-cell mdl-cell--12-col content-align-center">
                            <template is="dom-if" if={{!prospectIndicatorFlag}}>
                            <div class="border-round-brand-color mdl-grid padding-t-zero padding-b-zero text-brand-color">
                                    <paper-button on-tap="createAccountDIB">
                                        <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                                    </paper-button>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div hidden$={{!desktop}}>
                        <template is="dom-if" if={{!prospectIndicatorFlag}}>
                            <div class="padding-4px padding-l-zero">
                                <paper-button class="margin-zero  border-round-brand-color padding-4px text-brand-color font-size-s" on-tap="createAccountDIB">
                                    <oe-i18n-msg msgid="b_apply"></oe-i18n-msg>
                                </paper-button>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </template>
        </div>
        <div class="mdl-grid full-width">
        <app-dialog  id="dashboard_user_card_reapply" elementid="CreditCardReapply">
                <div class="mdl-grid">
                        <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop">
                            <oe-i18n-msg class="header-dark padding-t-zero content-align-center" msgid="m_CcReapply"></oe-i18n-msg>
                        </div>
            
                        <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop">
                            <oe-i18n-msg class="text-brand-color font-size-m" msgid="m_ViewDetails"></oe-i18n-msg>
                        </div>
            
                        <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop"></div>
            
                        <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop">
                            <oe-i18n-msg class="secondary-dark-text-s" msgid="m_ApplyNew"></oe-i18n-msg>
                        </div>
            
                    </div>
            
                        <div class="border-b-1px"></div>
            
                        <div class="">
                            <paper-button id="cancelButton" on-tap="">
                                <oe-i18n-msg class="text-brand-color" msgid="b_cancelreq"></oe-i18n-msg>
                            </paper-button>
                        </div>
        </app-dialog>
    </div>`;

Polymer({
    is: 'dashboard-user-card',
    behaviors: [corpBehaviours.appMenuBehaviour, accessibilityBehaviours.commonFunctions],
    _template: template,
    properties: {
        cards: {
            type: Array,
            notify: true,
            observer: '_cardsListChanged'
        },
        cardLoader: {
            type: Boolean,
            value: true,
            notify: true
        },
        cardsAccountSchemes: {
            type: Array,
            value: ['CCD']
        },
        cardsAmountList: {
            type: Array,
            notify: true
        },
        lastBilledAmount: {
            type: String,
            notify: true
        },
        cardsAvailable: {
            type: Boolean,
            value: true,
            notify: true
        },
        cardsSuggestions: {
            type: Object,
            notify: true
        },
        prospectIndicatorFlag: {
            type: Object,
            computed: 'computeProspectIndicator()'
        },
        menuId: {
            type: String,
            notify: true,
            value: "ORCRD"
        },
        isMenuId: {
            type: Boolean,
            notify: true,
            observer: 'cardabc'
        }
    },
    attached: function () {
        // this.isMenuId = this.validateElement(this.menuId);
        this.set('isMenuId', this.validateElement(this.menuId))
    },
    computeProspectIndicator: function () {
        return clientStorage.get(storageType.session, "prospectIndicator") == "Y";
    },

    _addClassBasedOnDevice: function (desktop) {
        if (desktop)
            return "";
        return "text-align-center";
    },
    _goToSuggestion: function () {
        var url = this.cardsSuggestions.url;
        window.oe_navigate_to(url, "");
    },
    _navigateToCard: function () {
        if (this.isMenuId)
            return;
        if (this.cards.length == 0)
            this._applyCreditCard();
        else if (this.cards.length > 1) {
            let detailsURL = "/credit-card-dashboard";
            let detailsNavigationData = {};
            if (!window.google || !window.google.charts) {
                var script = document.createElement('script');
                script.type = "application/javascript";
                script.async = false;
                script.src = 'https://www.gstatic.com/charts/loader.js';
                script.onload = function () {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                script.onerror = function () {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                document.head.appendChild(script);
            } else {
                window.oe_navigate_to(detailsURL, detailsNavigationData);
            }
        } else {
            let detailsURL = "/credit-card-detail";
            let detailsNavigationData = {
                creditCardNumber: this.cards[0].accountId
            };
            if (!window.google || !window.google.charts) {
                var script1 = document.createElement('script');
                script1.type = "application/javascript";
                script1.async = false;
                script1.src = 'https://www.gstatic.com/charts/loader.js';
                script1.onload = function () {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                script1.onerror = function () {
                    window.oe_navigate_to(detailsURL, detailsNavigationData);
                }
                document.head.appendChild(script1);
            } else {
                window.oe_navigate_to(detailsURL, detailsNavigationData);
            }
        }
    },
    _cardsListChanged: function () {
        var currencyValueList = [];
        var currencyValueMap = {};
        var cardsAmountList = [];
        var currencyValueBilledAmountList = [];
        var currencyValueBilledAmountMap = {};
        var pageTitle = document.getElementById('page-title-label');
        if (this.cards) {
            if (this.cards.length > 0) {
                for (var i = 0; i < this.cards.length; i++) {
                    if (this.cardsAccountSchemes.indexOf(this.cards[i].accountType.cmCode) > -1) {
                        var account = this.cards[i];
                        for (var j = 0; j < account.balances.length; j++) {
                            if (account.balances[j].type == "availableCreditLimit") {
                                if (currencyValueMap[account.balances[j].amountDetails.currency] != undefined) {
                                    var temp = currencyValueMap[account.balances[j].amountDetails.currency];
                                    currencyValueList[temp] = Number(currencyValueList[temp]) + Number(account.balances[j].amountDetails.amount);
                                } else {
                                    currencyValueList.push(Number(account.balances[j].amountDetails.amount));
                                    currencyValueMap[account.balances[j].amountDetails.currency] = currencyValueList.length - 1;
                                }
                            }
                            if (account.balances[j].type == "lastBilledAmount") {
                                if (currencyValueBilledAmountMap[account.balances[j].amountDetails.currency] != undefined) {
                                    var temp1 = currencyValueBilledAmountMap[account.balances[j].amountDetails.currency];
                                    currencyValueBilledAmountList[temp1] = Number(currencyValueBilledAmountList[temp1]) + Number(account.balances[j].amountDetails.amount);
                                } else {
                                    currencyValueBilledAmountList.push(Number(account.balances[j].amountDetails.amount));
                                    currencyValueBilledAmountMap[account.balances[j].amountDetails.currency] = currencyValueBilledAmountList.length - 1;
                                }
                            }
                        }
                    }
                }

                for (let key in currencyValueMap) {
                    let index = currencyValueMap[key];
                    let val = currency.symbolize(key + ' ' + currencyValueList[index]);
				  var amountValue = val.slice(2, val.length);
				  amountValue = amountValue[amountValue.length - 3] == "." ? amountValue.slice(0, amountValue.length - 3) : amountValue;
				  var showTooltip = amountValue.length >= 4 ? true : false;
				  cardsAmountList.push({ "amount": val, "showTooltip": showTooltip });

                }

                for (let key in currencyValueBilledAmountMap) {
                    let index = currencyValueBilledAmountMap[key];
                    let val = currency.symbolize(key + ' ' + currencyValueBilledAmountList[index])
                    if (this.lastBilledAmount)
                        this.lastBilledAmount = this.lastBilledAmount + ", " + val;
                    else
                        this.lastBilledAmount = val;
                }

                this.cardsAmountList = cardsAmountList;
                if (this.$$("#dashboard_user_card_spinner") != null)
                    this.$$("#dashboard_user_card_spinner").active = false;
                this.cardLoader = false;
            } else if (pageTitle.appData.cardsSuggestionsCallDone === undefined) {
                var self = this;
                this.cardsAvailable = false;
                pageTitle.appData.cardsSuggestionsCallDone = true;
                if (this.prospectIndicatorFlag) {
                    if (this.$$("#dashboard_user_card_spinner") != null)
                        this.$$("#dashboard_user_card_spinner").active = false;
                    this.cardLoader = false;
                    this.set('cardsSuggestions', {});
                    pageTitle.appData.cardsSuggestions = this.cardsSuggestions;
                    return;
                }
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json";
                ajaxCall.url = "/api/accountSuggestions/cards";
                ajaxCall.method = 'get';
                ajaxCall.addEventListener('response', function (event) {
                    if (event.detail.response != null) {
                        var suggestions = event.detail.response.accountSuggestion;
                        suggestions.formattedAmount = currency.symbolize(suggestions.currency + ' ' + suggestions.amount);
                        self.set('cardsSuggestions', suggestions);
                        pageTitle.appData.cardsSuggestions = self.cardsSuggestions;
                    }
                    if (self.$$("#dashboard_user_card_spinner") != null)
                        self.$$("#dashboard_user_card_spinner").active = false;
                    self.cardLoader = false;
                });
                ajaxCall.addEventListener("error", function (e) {
                    self.serviceError(e);
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
            } else {
                if (this.$$("#dashboard_user_card_spinner") != null)
                    this.$$("#dashboard_user_card_spinner").active = false;
                this.cardLoader = false;
                this.cardsAvailable = false;
                if (pageTitle.appData.cardsSuggestions)
                    this.set('cardsSuggestions', pageTitle.appData.cardsSuggestions);
            }
        }
    },
    serviceError: function () {
        // this.fire("oe-show-error","Please try after sometime. Currently we are not able to process your request due to technicle issues");
        if (this.$$("#dashboard_user_card_spinner") != null)
            this.$$("#dashboard_user_card_spinner").active = false;
        this.cardLoader = false;
        this.set('cardsSuggestions', {});
        //TODO
        // log clientside issues 
    },

    _applyCreditCard: function () {
        var self = this;
        var fetchServiceRequest = document.createElement("oe-ajax");
        fetchServiceRequest.contentType = "application/json";
        fetchServiceRequest.handleAs = "json";
        fetchServiceRequest.url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/servicerequests" + "?filter[where][requestType.cmCode]=NCA";
        fetchServiceRequest.method = "GET";
        oeAjaxEventListner(fetchServiceRequest);
        fetchServiceRequest.generateRequest();
        fetchServiceRequest.addEventListener('response', function (event) {
            if (event.detail.response.length > 0) {
                self.$$("#dashboard_user_card_reapply").$$("#CreditCardReapply").open();
            } else {
                oe_navigate_to("/creditCardApply");
                $(mainContainer).scrollTop(0);
            }
        });
    },
    createAccountDIB: function () {
        var isExistingCustomer = "Y";
        var existingCustomerInfo = {};
	var self = this;
        existingCustomerInfo.isExistingCustomer = isExistingCustomer;
        //existingCustomerInfo.selectedProductCategories = ["CreditCard"];
        // Replacing the hardcoded values by fetching it from API call as part of feature 301794
        var ajaxCall = document.createElement('oe-ajax');
        ajaxCall.contentType = "application/json";
        ajaxCall.handleAs = "json";
        ajaxCall.url = "/api/retailproduct-categories?filter[where][mainCategory]=33";
        ajaxCall.method = 'get';
        ajaxCall.addEventListener('response', function(event) {
            let response = event.detail.response;
            existingCustomerInfo.selectedProductCategories = _.map(response.productCategoryDetails, function(prod) { return prod.productCategoryId.codeDescription });
            window.oe_navigate_to("/directbanking", {
                "existingCustomerInfo": existingCustomerInfo
            });
        });
        ajaxCall.addEventListener("error", function(e) {
            existingCustomerInfo.selectedProductCategories = [];
      var errMsg = JSON.parse(e.detail.request.__data.response.error.message["channelcontext"]);
      self.fire('oe-show-error', errMsg.status.message[0].messageDesc);
        });
        oeAjaxEventListner(ajaxCall);
        ajaxCall.generateRequest();
    },
    _navigateToCardDDA(keyboardEvent) {
        if (keyboardEvent.code === "Enter") {
            this._navigateToCard(keyboardEvent);
        }
    }
});
